/**
 * 审计系统国际化 - 中文
 */
export const auditZh = {
  title: '审计日志',
  refresh: '刷新',
  soxCompliance: 'SOX 合规',
  
  // 导航
  nav: {
    overview: '审计概览',
    logs: '审计日志',
    search: '高级搜索',
    statistics: '统计分析',
    financial: '财务审计',
    sensitive: '敏感操作',
    integrity: '完整性验证',
  },

  // 相对时间标签（被 formatRelativeTime util 消费）
  relativeTime: {
    justNow: '刚刚',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    daysAgo: '{n} 天前',
  },

  // 概览页
  overview: {
    title: '审计概览',
    description: '监控系统操作，确保合规性和安全性',
    lastSevenDays: '近 7 天操作',
    failedOperations: '失败操作',
    moduleDistribution: '模块分布',
    actionTypes: '操作类型',
    dailyTrend: '每日趋势',
    recentActivity: '最近活动',
    viewAll: '查看全部',
    noData: '暂无数据',
    noLogs: '暂无审计日志',
    loadFailed: '加载失败',
    retry: '重试',
    verifyIntegrity: '验证完整性',
    soxComplianceDesc: '审计日志已启用加密存储和完整性验证',
  },
  
  // 日志列表
  logs: {
    title: '审计日志',
    description: '查看和搜索系统操作日志',
    totalRecords: '共 {count} 条记录',
    perPage: '每页',
    records: '条',
    searchPlaceholder: '搜索操作描述、用户名...',
    advancedFilters: '高级筛选',
    clearFilters: '清除筛选',
    export: '导出',
    exportCSV: '导出 CSV',
    exporting: '导出中...',
  },
  
  // 日志详情
  detail: {
    title: '审计日志详情',
    basicInfo: '基本信息',
    changeDetails: '变更详情',
    contextInfo: '上下文信息',
    integrityInfo: '完整性信息',
    oldValue: '变更前',
    newValue: '变更后',
    changes: '变更内容',
    changeDetail: '变更详情',
    noChanges: '无变更记录',
    backToList: '返回列表',
    back: '返回',
    retry: '重试',
    loadFailed: '加载失败',
    logNotFound: '日志不存在',
    operationOverview: '操作概览',
    sensitive: '敏感',
    financial: '财务',
    who: 'Who (谁)',
    what: 'What (做什么)',
    when: 'When (何时)',
    where: 'Where (哪里)',
    how: 'How (如何)',
    why: 'Why (为什么)',
    module: '模块',
    status: '状态',
    riskLevel: '风险级别',
    operationDesc: '操作描述',
    targetEntity: '目标实体',
    entityType: '实体类型',
    entityId: '实体 ID',
    userId: '用户 ID',
    sessionId: '会话 ID',
    traceId: '追踪 ID',
    requestId: '请求 ID',
    ipAddress: 'IP 地址',
    userAgent: '用户代理',
    contentHash: '内容哈希',
    previousHash: '前一哈希',
    chainIndex: '链索引',
    createdAt: '创建时间',
    archivedAt: '归档时间',
    copySuccess: '已复制',
    actionType: '操作类型',
    complianceLevel: '合规级别',
    retentionYears: '保留年限',
    years: '年',
    duration: '执行耗时',
    errorMessage: '错误信息',
    deviceId: '设备 ID',
    businessType: '业务类型',
    businessKey: '业务键',
    region: '区域',
    tenantId: '租户 ID',
    currentHash: '当前哈希',
    signature: '数字签名',
    geoLocation: '地理位置',
    deviceType: '设备类型',
    deviceTypeDesktop: '桌面端',
    deviceTypeMobile: '移动端',
    operatingSystem: '操作系统',
    browser: '浏览器',
    operationSource: '操作来源',
    viewSource: '查看原始单据',
    verifyIntegrity: '校验完整性',
    verifying: '校验中...',
    integrityValid: '✓ 未篡改',
    integrityInvalid: '✗ 已被篡改',
    integrityVerifyFailed: '校验失败',
    integrityTamperedHint: '存储哈希与重新计算的哈希不匹配，记录可能被篡改',
    diff: {
      summary: '共 {count} 项变更',
      unchangedSuffix: '，{count} 项未变',
      showUnchanged: '显示未变字段',
      hideUnchanged: '隐藏未变字段',
      noChanges: '无变更字段',
      tagAdded: '新增',
      tagRemoved: '删除',
      tagModified: '修改',
      tagUnchanged: '未变',
    },
  },
  
  // 高级搜索
  search: {
    title: '高级搜索',
    description: '按实体、用户或追踪 ID 搜索审计记录',
    entityHistory: '实体历史',
    userOperations: '用户操作',
    traceChain: '请求链路',
    entityType: '实体类型',
    entityId: '实体 ID',
    userId: '用户 ID',
    traceId: '追踪 ID',
    search: '搜索',
    searching: '搜索中...',
    invalidUUID: '⚠️ 无效的 UUID 格式',
    validFormat: '✓ 格式正确',
    uuidHint: '请输入标准 UUID 格式（36 位，含连字符）',
    entityHistoryTitle: '实体操作历史',
    userSummary: '用户摘要',
    totalOperations: '总操作数',
    sensitiveOperations: '敏感操作',
    financialOperations: '财务操作',
    failedOperations: '失败操作',
    operationRecords: '操作记录',
    traceChainTitle: '请求链路',
    totalDuration: '总耗时',
    required: '*',
    entityTypePlaceholder: '如 User / users / Document（大小写不敏感）',
    entityIdPlaceholder: '550e8400-e29b-41d4-a716-446655440000',
    entityHistoryDesc: '查询特定实体的所有操作历史，包括创建、更新、删除等',
    userOperationsDesc: '查询特定用户的所有操作记录，包括操作统计摘要',
    traceChainDesc: '查询单个请求的完整调用链路，追踪跨服务调用',
    pleaseEnterEntityTypeAndId: '请输入实体类型和实体 ID',
    pleaseEnterUserId: '请输入用户 ID',
    pleaseEnterTraceId: '请输入追踪 ID',
    invalidUUIDFormat: '必须是有效的 UUID 格式（如：550e8400-e29b-41d4-a716-446655440000）',
    searchFailed: '搜索失败',
    totalRecords: '共 {count} 条记录',
    changedFields: '变更字段',
  },
  
  // 统计分析
  statistics: {
    title: '统计分析',
    description: '审计日志统计与趋势分析',
    moduleDistribution: '模块分布',
    actionTypes: '操作类型',
    actionDistribution: '操作类型分布',
    dailyTrend: '每日趋势',
    topUsers: '活跃用户',
    successRate: '成功率',
    timeRange: '时间范围',
    to: '至',
    quickSelect: '快捷',
    last7Days: '近 7 天',
    last30Days: '近 30 天',
    last90Days: '近 90 天',
    totalOperations: '总操作数',
    successOperations: '成功操作',
    failedOperations: '失败操作',
    financialOperations: '财务操作',
    sensitiveOperations: '敏感操作',
    loadFailed: '加载失败',
    loadingStatistics: '加载统计数据失败',
  },
  
  // 财务审计
  financial: {
    title: '财务操作',
    description: '查看财务相关的审计日志',
    retentionYears: '保留 {years} 年',
    soxCompliance: 'SOX 合规',
    soxComplianceDesc: '财务操作日志保留 7 年，支持完整性验证和审计追溯',
    timeRangeRequired: '时间范围 (必填，最长 1 年)',
    last7Days: '近 7 天',
    last1Month: '近 1 月',
    last3Months: '近 3 月',
    advancedFilters: '高级筛选',
    clearFilters: '清除',
    enterModuleName: '输入模块名称',
    enterUserId: '输入用户 ID',
    statisticsSummary: '统计摘要',
    totalRecords: '总记录数',
    actionDistribution: '操作类型分布',
    moduleDistribution: '模块分布',
    loadFailed: '加载财务审计日志失败',
  },
  
  // 敏感操作
  sensitive: {
    title: '敏感操作',
    description: '查看高风险和敏感操作日志',
    mfaVerified: 'MFA 已验证',
    requiresApproval: '需要审批',
    securityMonitoring: '安全监控',
    securityDesc: '敏感操作包括密码变更、权限调整、数据删除等高风险操作，需要特别关注',
    totalSensitiveOps: '总敏感操作',
    last7Days: '近 7 天',
    last1Month: '近 1 月',
    advancedFilters: '高级筛选',
    clearFilters: '清除',
    enterUserId: '输入用户 ID',
    totalSensitiveRecords: '共 {count} 条敏感操作记录',
    loadFailed: '加载敏感操作日志失败',
  },
  
  // 完整性验证
  integrity: {
    title: '完整性验证',
    description: '验证审计日志的完整性和不可篡改性',
    verify: '验证完整性',
    verifying: '验证中...',
    verified: '验证通过',
    failed: '验证失败',
    totalRecords: '检查记录数',
    passCount: '通过数',
    failCount: '失败数',
    failures: '失败详情',
    verifiedAt: '验证时间',
    duration: '耗时',
    startVerification: '开始验证',
    selectTimeRange: '选择时间范围',
    hashChainIntegrity: '哈希链完整性',
    hashChainDesc: '审计日志使用 SHA-256 哈希链技术确保数据完整性。每条日志都包含前一条日志的哈希值，形成不可篡改的链式结构。验证过程会检查每条记录的哈希值是否正确，以检测任何数据篡改。',
    immediateVerification: '即时验证',
    immediateVerificationDesc: '同步验证指定时间范围内的日志',
    startDate: '开始日期',
    endDate: '结束日期',
    recommendedTimespan: '建议时间跨度不超过 30 天，避免超时',
    backgroundCheck: '后台检查',
    backgroundCheckDesc: '异步执行大范围完整性检查',
    checkScope: '检查范围',
    allLogs: '全部日志',
    queueing: '排队中',
    executing: '执行中',
    completed: '已完成',
    triggerCheckFailed: '触发检查失败',
  },
  
  // 筛选条件
  filters: {
    actionType: '操作类型',
    status: '状态',
    riskLevel: '风险级别',
    module: '模块',
    startDate: '开始日期',
    endDate: '结束日期',
    onlyFinancial: '仅财务操作',
    onlySensitive: '仅敏感操作',
    all: '全部',
  },
  
  // 操作类型
  action: {
    create: '创建',
    read: '查看',
    update: '更新',
    delete: '删除',
    bulkUpdate: '批量更新',
    bulkDelete: '批量删除',
    approve: '审批通过',
    reject: '审批拒绝',
    return: '退回',
    forward: '转发',
    withdraw: '撤回',
    login: '登录',
    logout: '登出',
    loginFailed: '登录失败',
    passwordChange: '修改密码',
    passwordReset: '重置密码',
    emailChange: '修改邮箱',
    permissionChange: '权限变更',
    roleChange: '角色变更',
    configChange: '配置变更',
    backup: '备份',
    restore: '恢复',
    export: '导出',
    import: '导入',
    deploy: '部署',
    rollback: '回滚',
    payment: '付款',
    refund: '退款',
    invoiceGenerate: '生成发票',
    financialClose: '财务结账',
    budgetApprove: '预算审批',
    download: '下载',
    upload: '上传',
    share: '分享',
    archive: '归档',
  },
  
  // 状态
  status: {
    success: '成功',
    failed: '失败',
    partial: '部分成功',
    pending: '待处理',
  },
  
  // 风险级别
  riskLevel: {
    low: '低风险',
    medium: '中风险',
    high: '高风险',
  },
  
  // 模块名称
  module: {
    user: '用户管理',
    role: '角色管理',
    permission: '权限管理',
    department: '部门管理',
    position: '职位管理',
    form: '表单管理',
    approval: '审批流程',
    workRecord: '工时记录',
    part: '零件管理',
    inventory: '库存管理',
    ticket: '工单系统',
    notification: '通知管理',
    auth: '认证授权',
    system: '系统设置',
  },
  
  // 通用
  loading: '加载中...',
  loadFailed: '加载失败',
  retry: '重试',
  verifyIntegrity: '验证完整性',
  analysis: '分析',
  admin: '管理',
  
  // 空状态
  empty: {
    noData: '暂无数据',
    noLogs: '暂无审计日志',
    noResults: '未找到匹配的记录',
  },

  // 使用说明
  help: {
    title: '使用说明',
    subtitle: '快速了解审计系统',
    nav: '使用说明',
    intro: {
      title: '这是什么系统',
      paragraph:
        '审计系统记录所有重要操作的「谁、做了什么、何时、何地、为何、如何」（5W1H），通过哈希链防止日志被篡改，满足 SOX 合规与 7 年留存要求。开发无需手写日志——给方法加 @Auditable 装饰器即自动记录。',
      highlights: [
        { title: '5W1H 完整', desc: '操作人 / 操作内容 / 时间 / IP / 原因 / 来源逐字段记录' },
        { title: '防篡改', desc: 'SHA-256 哈希链 + DB 触发器禁 UPDATE/DELETE，单条可一键校验' },
        { title: 'SOX 合规', desc: '财务操作 7 年留存，自动生成 SOX/GDPR 合规报表' },
      ],
    },
    concepts: {
      title: '核心概念',
      description: '理解这几个词，再用系统就清楚了',
      items: [
        { term: '5W1H', desc: '一条审计记录的完整要素：Who（谁）/ What（做了什么）/ When（何时）/ Where（何地，IP + 设备）/ Why（原因）/ How（API/UI/CLI/系统）' },
        { term: '@Auditable', desc: '后端装饰器，标在方法上即自动记录该方法调用为审计事件，无需手写日志代码' },
        { term: '@Sensitive', desc: '敏感操作标记，归入敏感日志专表，可在"敏感操作"页查看' },
        { term: '@Financial', desc: '财务操作标记，触发 7 年长期留存，可在"财务审计"页查看' },
        { term: '哈希链', desc: '每条日志的 hash 包含前一条 hash，形成链式签名；任一条被改将导致后续全部校验失败' },
        { term: 'traceId', desc: '请求级追踪 ID，用于把同一次操作引发的多条日志串起来排查' },
        { term: 'businessKey', desc: '业务单号字段（审批 / 财务 / 表单单号）；在详情页可一键跳回原单' },
      ],
    },
    roles: {
      title: '角色与可见范围',
      description: '不同角色看到的审计日志范围不同',
      columnHeaders: {
        role: '角色',
        scope: '可见范围',
        desc: '说明',
      },
      items: [
        { code: 'Administrator', name: '系统管理员', scope: '全部', desc: '查看全部审计日志（含财务、敏感），可执行完整性校验' },
        { code: 'AuditAdmin', name: '审计管理员', scope: '全部', desc: '专责审计的角色，与系统管理员同等查看权' },
        { code: 'FinanceAuditor', name: '财务审计员', scope: '财务日志', desc: '查看财务审计页，金额 / 合同 / 付款类操作' },
        { code: 'SensitiveAuditor', name: '安全审计员', scope: '敏感日志', desc: '查看敏感操作页，权限变更 / 数据导出 / 超管操作' },
        { code: '一般业务用户', name: '业务用户', scope: '本人操作', desc: '通过 audit:read 权限控制，仅可看到自己产生的审计记录' },
      ],
    },
    tasks: {
      title: '常用任务',
      description: '点击卡片直接跳到对应功能页',
      cards: [
        { id: 'overview', name: '审计概览', desc: '近 7 天操作总量、失败趋势、模块分布' },
        { id: 'logs', name: '审计日志列表', desc: '按时间倒序浏览所有审计记录，支持模块 / 类型筛选' },
        { id: 'search', name: '高级搜索', desc: '按用户 / 实体 / 时间 / 业务单号精确检索' },
        { id: 'integrity', name: '完整性验证', desc: '校验日志哈希链是否被篡改' },
        { id: 'financial', name: '财务审计', desc: '金额 / 合同 / 付款类操作专用查询' },
        { id: 'sensitive', name: '敏感操作', desc: '权限变更 / 超管操作 / 数据导出监控' },
        { id: 'statistics', name: '统计分析', desc: '操作类型 / 趋势 / 模块维度统计图表' },
      ],
    },
  },
};
